module.exports = __webpack_public_path__ + "static/img/arrow-usual.922db17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-usual.png
// module id = AZOx
// module chunks = 1